import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'com-form-group-item',
  templateUrl: './form-group-item.component.html'
})
export class FormGroupItemComponent {}
